"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Inspired by
 * https://github.com/burakcan/mb
 */
function oc(data, path, defaultValue) {
    path.map(function (key) { return (data = (data || {})[key]); });
    return data == null ? defaultValue : data;
}
exports.oc = oc;
//# sourceMappingURL=runtime.js.map